import { HeaderProps, IdType, Renderer } from 'react-table';
import XLSX from 'xlsx';
import 'jspdf-autotable';
import { ExportData } from '../interfaces';

export const exportXlsx = (
  props: ExportData & {
    fileName: string;
  }
): void => {
  exportDataAsXlsx(props);
};

export const exportDataAsXlsx = <D extends object = any>({
  columns,
  data,
  fileName
}: {
  data: D[];
  columns: Array<{
    id?: IdType<D> | undefined;
    Header?: Renderer<HeaderProps<D>> | undefined;
    accessor?: any;
  }>;
  fileName: string;
}): void => {
  const filterColumns = columns.filter(
    (column) => column.Header != 'Row' && column.Header != 'Actions' && column.accessor != null
  );
  const headerNames = filterColumns.map((row) => row.Header) as string[];

  const compatibleData = data.map((row: any) => {
    const mappedData: any = {};
    filterColumns.forEach((column) => {
      mappedData[column.Header as string] = column.accessor(row);
    });
    return mappedData;
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(compatibleData, {
    header: headerNames
  });
  XLSX.utils.book_append_sheet(workbook, worksheet, 'React Table Data');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
